<app-preloader *ngIf="isLoading()"></app-preloader>
<app-notifications></app-notifications>
<form action="" [formGroup]="formGroup" novalidate tabindex="0">
  <!-- <button style="width: 100px;" (click)="status(formGroup)">Estado</button> -->

  <!-- Nombre y RoRAC -->
  <div class="nameAndRoRAC">
    <!-- Si se está editando un seguro incluir la clase "insurance" en el div.name -->
    <div class="wrapper">
      <div class="controlWrapper name">
        <label for="">Nombre <span class="required">*</span></label>
        <input
          name="dealName"
          id="dealName"
          formControlName="dealName"
          data-select-id="dealName"
          dataSelectId
          tabindex="1"
        />
      </div>
      @if (featureLoyaltyFeriaQuotation && !customerFeriaForLoyaltyUi()) {
        <div class="loyaltyDealCheck" aria-label="Loyalty por propuesta">
          <label class="checkboxWrapper" for="openDealLoyalty">
            <input type="checkbox" id="openDealLoyalty" formControlName="dealIsLoyalty" />
            <span class="checkmark"></span>
            <span class="description">Propuesta Loyalty</span>
            <span class="loyaltyBadge" aria-hidden="true"><img src="./assets/images/icons/loyalty.svg" alt="" /></span>
          </label>
        </div>
      }
    </div>
    <div class="controlWrapper rorac">
      <label for="">RoRAC</label>

      <input
        type="number"
        name="roRac"
        id="roRac"
        formControlName="roRac"
        (keypress)="preventInvalidCharacters($event)"
        tabindex="2"
      />
      <span>%</span>
    </div>
  </div>

  <!-- Información contractual -->
  <div class="contract edition" id="contract-edition">
    <div class="titleWrapper">
      <h4>Información contractual</h4>
      <a
        class="accordionControl"
        (click)="collapse()"
        (keydown.enter)="collapse()"
        style="cursor: pointer"
        tp="{{ collapsed ? 'Ver detalle' : 'Ocultar detalle' }}"
        tabindex="3"
        ></a
      >
    </div>
    <div class="accordionWrapper">
      <div>
        <div class="mainWrapper">
          <!-- Parámetros -->
          <div class="parameters">
            <!-- General -->
            <div class="general">
              <div class="control">
                <!-- Producto financiero -->
                <label>{{ 'Financial product' | translate }}<span class="required">*</span></label>
                <div class="selectWrapper">
                  <div class="customSelect">
                    <select
                      formControlName="financialProductType"
                      data-select-id="financialProductType"
                      dataSelectId
                      (change)="selectFinacialProduct()"
                      tabindex="4"
                    >
                      @for (product of financialProductList(); track product.value) {
                        <option [value]="product.value">
                          {{ product.name }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>

              <!-- Plazo -->
              <div class="control">
                <label>{{ 'Term' | translate }} <span class="required">*</span></label>
                <div>
                  <input
                    type="number"
                    formControlName="term"
                    class="size0 textAlignRight"
                    (keypress)="preventInvalidCharacters($event)"
                    (blur)="onChangeTerm()"
                    data-select-id="term"
                    dataSelectId
                    tabindex="5"
                    appInputValidations
                    [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                    [maxValue]="ConstantsComp.MAX_TERMS_FOR_SPECIAL_PRODUCT"
                  />
                  <span>{{ term }}</span>
                </div>
              </div>

              <!-- Segmento OPEX -->
              <div class="control">
                <label>{{ 'OPEX Segment' | translate }}</label>
                <div class="selectWrapper">
                  <div class="customSelect">
                    <select formControlName="opexSegment" tabindex="6">
                      @for (segment of financialCalculator.segmentOpex; track segment.value) {
                        <option [value]="segment.value">
                          {{ segment.name }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>

              <!-- Moneda -->
              <div class="control">
                <label>{{ 'Currency' | translate }} <span class="required">*</span></label>
                <div>
                  <div class="selectWrapper">
                    <div class="customSelect">
                      <select formControlName="currencyType" tabindex="7" (change)="onChangeCurrencyType()">
                        @for (currency of financialCalculator.currencies; track currency.value) {
                          <option [value]="currency.value">
                            {{ currency.type }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Cotización USD -->
              <div class="control">
                <label>{{ 'USD Quote' | translate }}</label>
                <div>
                  <input
                    type="number"
                    class="size0 textAlignRight"
                    formControlName="quoteUsd"
                    (keypress)="preventInvalidCharacters($event)"
                    tabindex="8"
                    appInputValidations
                    [minValue]="ConstantsComp.MIN_NUMBER_FOR_NOT_DECIMALS"
                    [maxDecimals]="ConstantsComp.MAX_DECIMALS_FOR_NUMBERS"
                    [maxValue]="ConstantsComp.MAX_VALUE_FOR_NUMBERS"
                  />
                  <span>MXN</span>
                </div>
              </div>

              <!-- IVA -->
              <div class="control">
                <label>{{ 'VAT' | translate }}</label>
                <div>
                  <input
                    type="number"
                    class="size0 percentage textAlignRight"
                    formControlName="tax"
                    (blur)="calculateUnitPriceWithTax('unitPriceWithTax')"
                    (keypress)="preventInvalidCharacters($event)"
                    data-select-id="tax"
                    dataSelectId
                    tabindex="9"
                    appInputValidations
                  />
                  <span>%</span>
                </div>
              </div>

              <!-- Exento IVA -->
              <div class="control">
                <label>{{ 'VAT exempt' | translate }} <span class="required">*</span></label>
                @if (noVatExemptVisible) {
                  <span>NO</span>
                } @else {
                  <div>
                    <div class="selectWrapper">
                      <div class="customSelect">
                        <select formControlName="taxFree" (change)="calculateFinacialAmountUpdate()" tabindex="10">
                          @for (option of taxFreeOptions; track option.value) {
                            <option [value]="option.value">
                              {{ option.display }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <!-- Tasa al cliente -->
              <div class="control">
                <label>{{ 'Customer Rate' | translate }} <span class="required">*</span></label>
                <div>
                  <input
                    type="number"
                    formControlName="customerRate"
                    class="size0 percentage textAlignRight"
                    (blur)="onlyChangeValue()"
                    (keypress)="preventInvalidCharacters($event)"
                    data-select-id="customerRate"
                    dataSelectId
                    tabindex="11"
                    appInputValidations
                  />
                  <span>%</span>
                </div>
              </div>
            </div>

            <!-- Información vehículo -->
            <div class="vehicle" *ngIf="!isCapLoanOrRealEstate()">
              <!-- Datos -->
              <div class="data">
                <div class="row">
                  <!-- Tipo de producto -->
                  <div class="col">
                    <label>{{ 'Product type' | translate }} <span class="required">*</span></label>
                    <div class="selectWrapper">
                      <div class="customSelect">
                        <select
                          formControlName="productType"
                          data-select-id="productType"
                          dataSelectId
                          (change)="selectProduct()"
                          tabindex="12"
                        >
                          <option [value]="null" hidden selected>Seleccione un tipo de producto</option>
                          @for (product of financialCalculator.productType; track product.value) {
                            <option [value]="product.value" *ngIf="product.isValidToSelect(!isActiveBrokerCatalog)">
                              {{ product.name }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Check modelo de catálogo-->
                  <div class="col">
                    <label class="checkboxWrapper" for="modeloCatalogo" data-select-id="includesInsurance" dataSelectId>
                      <input
                        type="checkbox"
                        id="modeloCatalogo"
                        formControlName="includesInsurance"
                        (change)="onChangeIncludesInsurance($event)"
                        tabindex="13"
                      />
                      <span class="checkmark"></span>
                      <span class="description">{{ 'brokerCatalog' | translate }}</span>
                    </label>
                  </div>
                </div>
                @if (isActiveBrokerCatalog) {
                  <!-- Opciones para modelo de catálogo -->
                  <div class="catalog">
                    <div class="row">
                      <!-- Condición -->
                      <div class="col">
                        <label>{{ 'Condition' | translate }}</label>
                        @if (isAccesoriesProduct && isActiveAccesoriesMarsh) {
                          <span>{{ getClassificationOptions() | translate }}</span>
                        } @else {
                          <div class="selectWrapper">
                            <div class="customSelect">
                              <select
                                formControlName="classification"
                                data-select-id="classification"
                                dataSelectId
                                (change)="onChangeClassification()"
                                tabindex="14"
                              >
                                @for (option of classificationOptions; track option.value) {
                                  <option [value]="option.value" *ngIf="option.isValidToSelect(isActiveBrokerCatalog)">
                                    {{ option.display | translate }}
                                  </option>
                                }
                              </select>
                            </div>
                          </div>
                        }
                      </div>

                      <!-- MOSTRAR SOLO SI LA CONDICIÓN ES USADO -->
                      <!-- Tiempo de uso -->
                      @if (isUsedClassification) {
                        <div class="col">
                          <label>{{ 'Usage Time' | translate }} <span class="required">*</span></label>
                          <div>
                            <input
                              type="number"
                              formControlName="useTime"
                              class="size0 textAlignRight"
                              (blur)="onCHnageUseTime()"
                              tabindex="15"
                              appInputValidations
                              [maxValue]="ConstantsComp.MAX_USE_TIME_FOR_PRODUCTS"
                              [minValue]="ConstantsComp.MIN_USE_TIME_FOR_PRODUCTS"
                              [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                            />
                            <span>{{ 'Months' | translate }}</span>
                          </div>
                        </div>
                      }
                    </div>

                    <div class="row">
                      <!-- Cantidad -->
                      <div class="col">
                        <label>{{ 'Amount' | translate }} <span class="required">*</span></label>
                        <input
                          type="number"
                          formControlName="quantity"
                          (blur)="changeQuantity()"
                          class="size0 textAlignRight"
                          data-select-id="quantity"
                          dataSelectId
                          tabindex="16"
                          appInputValidations
                          [maxValue]="ConstantsComp.MAX_QUANTITY_FOR_NORMAL_PRODUCT"
                          [minValue]="ConstantsComp.MIN_QUANTITY_FOR_NORMAL_PRODUCT"
                          [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                        />
                      </div>
                      <!-- Año -->
                      <div class="col">
                        <label>{{ 'Year' | translate }} <span class="required">*</span></label>
                        <!-- Select nuevo -->
                        <div class="selectWrapper">
                          <div class="customSelect">
                            <select
                              formControlName="year"
                              data-select-id="year"
                              dataSelectId
                              (change)="changeYear($event)"
                              tabindex="17"
                            >
                              <option [value]="null" disabled hidden selected>Seleccione un año</option>
                              @for (year of yearsListByProduct(); track year) {
                                <option [value]="year.value" [hidden]="year.value === null">
                                  {{ year.name }}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <!-- Modelo -->
                      <div class="colX2">
                        <label>{{ 'Model' | translate }} <span class="required">*</span></label>
                        <div class="selectWrapper">
                          <div class="customSelect">
                            <select
                              formControlName="modelId"
                              data-select-id="modelId"
                              dataSelectId
                              (change)="changeModel($event)"
                              tabindex="18"
                            >
                              <option [value]="null" hidden selected>Buscar modelo</option>
                              @for (product of productListFiltered(); track product.modelCode) {
                                <option [value]="product.id" [disabled]="!product.enabled">
                                  {{ getModelNameWithCode(product) }}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <!-- Marca -->
                      @if (!isAccesoriesProduct || !isActiveAccesoriesMarsh) {
                        <div class="col">
                          <label>{{ 'Brand' | translate }}</label>
                          <span>{{ modelBrandName }}</span>
                        </div>
                      }
                      <!-- Submarca -->
                      <div class="col">
                        <label>{{
                          (isAccesoriesProduct && isActiveAccesoriesMarsh ? 'Model' : 'Sub-brand') | translate
                        }}</label>
                        <span>{{ modelSubBrandName }}</span>
                      </div>
                    </div>
                  </div>
                } @else {
                  <!-- Opciones para modelo fuera de catálogo -->
                  <div class="noCatalog">
                    <div class="row">
                      <!-- Marca -->
                      @if (!isAccesoriesProduct && isActiveAccesoriesMarsh) {
                        <div class="col">
                          <label>{{ 'Brand' | translate }}</label>
                          <div class="selectWrapper">
                            <div class="selectWrapper">
                              <div class="customSelect">
                                <select
                                  formControlName="brandId"
                                  (change)="onBrandChange($event)"
                                  data-select-id="brandId"
                                  dataSelectId
                                  tabindex="14"
                                >
                                  @if (brands && brands.length < 1) {
                                    <option [value]="null" selected hidden>Sin Marca disponible</option>
                                  } @else {
                                    <option [value]="null" hidden>Seleccione una marca</option>
                                    @for (brand of brands; track brand.id) {
                                      <option [value]="brand.id">
                                        {{ brand.name }}
                                      </option>
                                    }
                                  }
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      <!-- Submarca -->
                      <div class="col">
                        <label>{{
                          (isAccesoriesProduct && isActiveAccesoriesMarsh ? 'Model' : 'Sub-brand') | translate
                        }}</label>
                        <div class="selectWrapper">
                          <div class="selectWrapper">
                            <div class="customSelect">
                              <select
                                formControlName="subBrandId"
                                (change)="onSubBrandChange($event)"
                                data-select-id="subBrandId"
                                dataSelectId
                                tabindex="15"
                              >
                                @if (subBrands && subBrands.length < 1) {
                                  <option [value]="null" selected hidden>Sin Submarcas Disponibles</option>
                                } @else {
                                  <option [value]="null" hidden>Seleccione una submarca</option>
                                  @for (sub of subBrands; track sub.id) {
                                    <option [value]="sub.id">
                                      {{ sub.name }}
                                    </option>
                                  }
                                }
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <!-- Condición -->
                      <div class="col">
                        <label>{{ 'Condition' | translate }}</label>
                        <div class="selectWrapper">
                          <div class="customSelect">
                            <select formControlName="classification" (change)="onChangeClassification()" tabindex="16">
                              @for (option of classificationOptions; track option.value) {
                                <option [value]="option.value" *ngIf="option.isValidToSelect(isActiveBrokerCatalog)">
                                  {{ option.display | translate }}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                      <!-- Tiempo de uso -->
                      @if (isUsedClassification) {
                        <div class="col">
                          <label>{{ 'Usage Time' | translate }} <span class="required">*</span></label>
                          <div>
                            <input
                              type="number"
                              formControlName="useTime"
                              class="size0 textAlignRight"
                              (blur)="onlyChangeValue()"
                              tabindex="17"
                              appInputValidations
                              [maxValue]="ConstantsComp.MAX_USE_TIME_FOR_PRODUCTS"
                              [minValue]="ConstantsComp.MIN_USE_TIME_FOR_PRODUCTS"
                              [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                            />
                            <span>{{ 'Months' | translate }}</span>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="row">
                      <!-- Cantidad -->
                      <div class="col">
                        <label>{{ 'Amount' | translate }} <span class="required">*</span></label>
                        <input
                          type="number"
                          formControlName="quantity"
                          (blur)="changeQuantity()"
                          class="size0 textAlignRight"
                          data-select-id="quantity"
                          dataSelectId
                          tabindex="18"
                          appInputValidations
                          [maxValue]="ConstantsComp.MAX_QUANTITY_FOR_NORMAL_PRODUCT"
                          [minValue]="ConstantsComp.MIN_QUANTITY_FOR_NORMAL_PRODUCT"
                          [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                        />
                      </div>
                      <!-- Características -->
                      <div class="col">
                        <label>{{ 'Characteristics' | translate }}</label>
                        <textarea cols="30" rows="10" formControlName="feature" tabindex="19"></textarea>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <!-- Imagen -->
              <div class="photo">
                <div class="wrapper">
                  @if (showImg) {
                    <!-- Si tiene imagen mostrar picture-->
                    <picture>
                      <img [src]="imageSB" alt="Marca Submarca" />
                    </picture>
                  } @else {
                    <!-- Si no tiene imagen mostrar div.noImage-->
                    <div class="noImage">
                      <span>{{ 'No image' | translate }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>

            <!-- Condiciones -->
            <div class="conditions">
              <!-- Concepto -->
              <div class="row" *ngIf="isCapLoanOrRealEstate()">
                <label>{{ 'Concept' | translate }}</label>
                <textarea cols="30" rows="10" formControlName="feature" tabindex="20"></textarea>
              </div>
              <!-- Precio unitario -->
              <div class="row" *ngIf="!isCapLoanOrRealEstate()">
                <div class="wrapperS1">
                  <div class="wrapperSX">
                    <label>{{ 'Unit Price' | translate }} <span class="required">*</span></label>
                    <span class="note">{{ 'Excluding VAT' | translate }}</span>
                  </div>
                </div>
                <div class="wrapperS2">
                  <input
                    type="number"
                    id="unitPriceWithoutTax"
                    class="amount xl"
                    style="display: none"
                    formControlName="unitPriceWithoutTax"
                    (blur)="calculateUnitPriceWithoutTax('unitPriceWithoutTax')"
                    (keypress)="preventInvalidCharacters($event)"
                    tabindex="21"
                  />
                  <input
                    data-select-id="unitPriceWithoutTax"
                    dataSelectId
                    type="text"
                    id="hidden-unitPriceWithoutTax"
                    class="amount xl"
                    (focus)="showAmountInput('unitPriceWithoutTax')"
                    style="display: block"
                    [value]="ctr['unitPriceWithoutTax'].value | currency: '' : ''"
                    tabindex="21"
                  />
                  <span>{{ currencySelected() }}</span>
                </div>
                <div class="wrapperSX">
                  <span class="note">{{ 'Including VAT' | translate }}</span>
                  <input
                    type="number"
                    id="unitPriceWithTax"
                    class="amount xl"
                    style="display: none"
                    formControlName="unitPriceWithTax"
                    (blur)="calculateUnitPriceWithTax('unitPriceWithTax')"
                    (keypress)="preventInvalidCharacters($event)"
                    tabindex="22"
                  />
                  <input
                    type="text"
                    id="hidden-unitPriceWithTax"
                    data-select-id="unitPriceWithTax"
                    dataSelectId
                    class="amount xl"
                    (focus)="showAmountInput('unitPriceWithTax')"
                    style="display: block"
                    [value]="ctr['unitPriceWithTax'].value | currency: '' : ''"
                    tabindex="22"
                  />
                  <span>{{ currencySelected() }}</span>
                </div>
              </div>
              <!-- Credito Inicial -->
              <div class="row" *ngIf="isCapLoanOrRealEstate()">
                <div class="wrapperS1">
                  <div class="wrapperSX">
                    <label>{{ 'Initial Credit' | translate }} <span class="required">*</span></label>
                    <span class="note">{{ 'Excluding VAT' | translate }}</span>
                  </div>
                </div>
                <div class="wrapperS2">
                  <input
                    type="number"
                    id="unitPriceWithoutTax"
                    class="amount xl"
                    style="display: none"
                    formControlName="unitPriceWithoutTax"
                    (blur)="calculateUnitPriceWithoutTax('unitPriceWithoutTax')"
                    (keypress)="preventInvalidCharacters($event)"
                    tabindex="23"
                  />
                  <input
                    data-select-id="unitPriceWithoutTax"
                    dataSelectId
                    type="text"
                    id="hidden-unitPriceWithoutTax"
                    class="amount xl"
                    (focus)="showAmountInput('unitPriceWithoutTax')"
                    style="display: block"
                    [value]="ctr['unitPriceWithoutTax'].value | currency: '' : ''"
                    tabindex="23"
                  />
                  <span>{{ currencySelected() }}</span>
                </div>
                <div class="wrapperSX">
                  <span class="note">{{ 'Including VAT' | translate }}</span>
                  <input
                    type="number"
                    id="unitPriceWithTax"
                    class="amount xl"
                    style="display: none"
                    formControlName="unitPriceWithTax"
                    (blur)="calculateUnitPriceWithTax('unitPriceWithTax')"
                    (keypress)="preventInvalidCharacters($event)"
                    tabindex="24"
                  />
                  <input
                    type="text"
                    id="hidden-unitPriceWithTax"
                    [attr.data-select-id]="'unitPriceWithTax'"
                    dataSelectId
                    class="amount xl"
                    (focus)="showAmountInput('unitPriceWithTax')"
                    style="display: block"
                    [value]="ctr['unitPriceWithTax'].value | currency: '' : ''"
                    tabindex="24"
                  />
                  <span>{{ currencySelected() }}</span>
                </div>
              </div>

              <!-- Total venta -->
              <div class="row" *ngIf="!isCapLoanOrRealEstate()">
                <div class="wrapperS1">
                  <div class="wrapperSX">
                    <label>{{ 'Total sale' | translate }}</label>
                    <span class="note" *ngIf="ctr['totalPriceWithoutTax'].value">Sin IVA</span>
                  </div>
                </div>
                <div class="wrapperS2">
                  <span class="amountReadOnly xl">{{
                    ctr['totalPriceWithoutTax'].value ? (ctr['totalPriceWithoutTax'].value | currency: '' : '') : ''
                  }}</span>
                  <span *ngIf="ctr['totalPriceWithoutTax'].value">{{ currencySelected() }}</span>
                </div>
                <div class="wrapperSX">
                  <span class="note" *ngIf="ctr['totalPriceWithTax'].value">Con IVA</span>
                  <div>
                    <span class="amountReadOnly xl">{{
                      ctr['totalPriceWithTax'].value ? (ctr['totalPriceWithTax'].value | currency: '' : '') : ''
                    }}</span>
                    <span *ngIf="ctr['totalPriceWithTax'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
              </div>

              <!-- Enganche -->
              <div class="row" *ngIf="isViewDownPayment">
                <div class="wrapperS1">
                  <label class="size2">{{ 'Down Payment' | translate }} <span class="required">*</span></label>
                </div>
                <div class="wrapperSX">
                  <div class="innerWrapper">
                    <div class="selectWrapper size2 gapRight">
                      <div class="customSelect">
                        <select formControlName="downPaymentTaxType" (change)="calculateDownPayment()" tabindex="25">
                          @for (taxType of taxTypeDownPaymentOptions; track taxType) {
                            <option
                              *ngIf="taxType.isValidToSelect(ctr['financialProductType'].value)"
                              [value]="taxType.value"
                            >
                              {{ taxType.display }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                    <ng-container *ngIf="ctr['downPaymentTaxType'].value">
                      <ng-container *ngIf="isDownPaymentTypeVariable">
                        <input
                          type="number"
                          formControlName="downPaymentTax"
                          (blur)="calculateDownPayment()"
                          class="size0 percentage textAlignRight gapRight"
                          (keypress)="preventInvalidCharacters($event)"
                          tabindex="26"
                          appInputValidations
                        />
                      </ng-container>
                      <span *ngIf="isDownPaymentTypeVariable">%</span>
                    </ng-container>
                  </div>
                  <div class="innerWrapper">
                    <input
                      type="number"
                      id="downPayment"
                      class="amount gapRight"
                      style="display: none"
                      (blur)="calculateDownPayment('downPayment')"
                      (keypress)="preventInvalidCharacters($event)"
                      formControlName="downPayment"
                      tabindex="27"
                      appInputValidations
                      [maxValue]="maxDownPaymentValue"
                      [minValue]="ConstantsComp.MIN_NUMBER_FOR_NOT_DECIMALS"
                      [maxDecimals]="ConstantsComp.MAX_DECIMALS_FOR_NUMBERS"
                    />
                    <input
                      type="text"
                      id="hidden-downPayment"
                      class="amount gapRight"
                      (focus)="showAmountInput('downPayment')"
                      [disabled]="isDownPaymentTypeVariable"
                      style="display: block"
                      [value]="ctr['downPayment'].value | currency: '' : ''"
                      tabindex="27"
                    />
                    <span *ngIf="ctr['downPayment'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
              </div>

              <!-- Monto a financiar -->
              <div class="row">
                <div class="wrapperS1">
                  <label>{{ 'Amount to Finance' | translate }}</label>
                </div>
                <div class="wrapperSX flexEnd">
                  <span class="amountReadOnly" [style]="financialAmountStyle">{{
                    ctr['financialAmount'].value ? (ctr['financialAmount'].value | currency: '' : '') : ''
                  }}</span>
                  <span *ngIf="ctr['financialAmount'].value">{{ currencySelected() }}</span>
                </div>
              </div>

              <!-- Comisión por apertura -->
              <div class="rowGroup">
                <div class="row">
                  <div class="wrapperS1">
                    <label>{{ 'Opening Fee' | translate }} <span class="required">*</span></label>
                  </div>
                  <div class="wrapperS4">
                    <input
                      type="number"
                      formControlName="openingFeePercentage"
                      (blur)="calculateCommissionForOpening()"
                      class="size0 percentage textAlignRight"
                      (keypress)="preventInvalidCharacters($event)"
                      required
                      tabindex="28"
                      appInputValidations
                    />
                    <span *ngIf="isOpeningFeeTypeVariable">%</span>
                  </div>
                </div>
                <!-- Comisión por apertura (línea 2)-->
                <div class="row">
                  <div class="wrapperS1">
                    <div class="wrapperSX">
                      <label></label>
                      <span class="note">{{ 'Excluding VAT' | translate }}</span>
                    </div>
                  </div>
                  <div class="wrapperS2">
                    <span class="amountReadOnly xl gapRight" [style]="openingFeeWithoutTaxStyle">{{
                      ctr['openingFeeWithoutTax'].value | currency: '' : ''
                    }}</span>
                    <span *ngIf="ctr['openingFeeWithoutTax'].value">{{ currencySelected() }}</span>
                  </div>
                  <div class="wrapperSX">
                    <span class="note">{{ 'Including VAT' | translate }}</span>
                    <div>
                      <span class="amountReadOnly xl" [style]="openingFeeWithTaxStyle">{{
                        ctr['openingFeeWithTax'].value | currency: '' : ''
                      }}</span>
                      <span *ngIf="ctr['openingFeeWithTax'].value">{{ currencySelected() }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Depósitos en garantía -->
              <div class="row">
                <div class="wrapperS1">
                  <label>{{ 'Security Deposits' | translate }} </label>
                </div>
                <div class="wrapperSX">
                  <div class="innerWrapper">
                    <div class="selectWrapper size2">
                      <div class="customSelect">
                        <select
                          formControlName="warrantyDeposit"
                          (change)="onChangeWarrantyDepositSelectorValue('warrantyDeposit')"
                          [attr.data-selected]="ctr['warrantyDeposit'].value"
                          tabindex="31"
                        >
                          @for (taxType of taxTypeWarrantyOptions; track taxType) {
                            <option
                              *ngIf="taxType.isValidToSelect(ctr['financialProductType'].value)"
                              [value]="taxType.value"
                            >
                              {{ taxType.display }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                    <ng-container *ngIf="ctr['warrantyDeposit'].value">
                      <ng-container *ngIf="isWarrantyDepositNotFixedOrRentBased">
                        <input
                          type="number"
                          formControlName="warrantyDepositPercentage"
                          (blur)="onChangeWarrantyDepositValue()"
                          class="size0 percentage textAlignRight gapRight"
                          (keypress)="preventInvalidCharacters($event)"
                          tabindex="32"
                          appInputValidations
                        />
                      </ng-container>

                      <ng-container *ngIf="isWarrantyDepositRentBased">
                        <input
                          type="number"
                          formControlName="warrantyDepositMonth"
                          (blur)="onChangeWarrantyDepositValue()"
                          class="size0 textAlignRight"
                          (keypress)="preventInvalidCharacters($event)"
                          tabindex="32"
                          appInputValidations
                          [maxValue]="ctr['term'].value"
                          [minValue]="ConstantsComp.MIN_NUMBER_FOR_NOT_DECIMALS"
                          [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                        />
                      </ng-container>

                      <span *ngIf="isWarrantyDepositNotFixedOrRentBased">%</span>
                    </ng-container>
                  </div>
                  <div class="innerWrapper">
                    <input
                      type="number"
                      id="warrantyDepositTotal"
                      class="amount"
                      style="display: none"
                      (blur)="onlyChangeValue('warrantyDepositTotal')"
                      formControlName="warrantyDepositTotal"
                      (keypress)="preventInvalidCharacters($event)"
                      tabindex="33"
                      appInputValidations
                      [maxValue]="ctr['unitPriceWithTax'].value"
                      [minValue]="ConstantsComp.MIN_NUMBER_FOR_NOT_DECIMALS"
                      [maxDecimals]="ConstantsComp.MAX_DECIMALS_FOR_NUMBERS"
                    />
                    <input
                      *ngIf="ctr['warrantyDepositTotal'].value"
                      type="text"
                      id="hidden-warrantyDepositTotal"
                      class="amount gapRight"
                      (focus)="showAmountInput('warrantyDepositTotal')"
                      [disabled]="isWarrantyDepositNotFixedAmount"
                      tabindex="33"
                      [value]="ctr['warrantyDepositTotal'].value | currency: '' : ''"
                    />
                    <span *ngIf="ctr['warrantyDepositTotal'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
              </div>

              <!-- Subsidio -->
              <div class="rowGroup">
                <div class="row">
                  <div class="wrapperS1">
                    <label>{{ 'Subsidy' | translate }}</label>
                  </div>
                  <div class="wrapperSX">
                    <div class="innerWrapper">
                      <div class="selectWrapper size2">
                        <div class="customSelect">
                          <select
                            formControlName="subsidyType"
                            (change)="changeSubsidy('subsidyTotalWithTax')"
                            data-select-id="subsidyType"
                            dataSelectId
                            tabindex="34"
                          >
                            @for (option of subsidyTypeOptions; track option) {
                              <option [value]="option.value">
                                @if (option.percentage) {
                                  %
                                }
                                {{ option.display | translate }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                      <ng-container *ngIf="isSubsidyTypeNotNull && isSubsidyTypeNotFixedAmount">
                        <input
                          type="number"
                          formControlName="subsidyPercentage"
                          (blur)="changeSubsidy('subsidyTotalWithTax')"
                          class="size0 percentage textAlignRight"
                          (keypress)="preventInvalidCharacters($event)"
                          data-select-id="subsidyPercentage"
                          dataSelectId
                          tabindex="35"
                          appInputValidations
                        />
                        <span *ngIf="isSubsidyTypeNotFixedAmount">%</span>
                      </ng-container>
                    </div>
                    <div class="innerWrapper" *ngIf="isSubsidyTypeNotEmpty && !isSubsidyTypeNotFixedAmount">
                      <input
                        type="number"
                        id="subsidyTotal"
                        class="amount gapRight"
                        style="display: none"
                        (blur)="changeSubsidy('subsidyTotalWithTax', 'subsidyTotal')"
                        formControlName="subsidyTotal"
                        (keypress)="preventInvalidCharacters($event)"
                        tabindex="36"
                      />
                      <input
                        type="text"
                        id="hidden-subsidyTotal"
                        class="amount gapRight"
                        (focus)="showAmountInput('subsidyTotal')"
                        [disabled]="isSubsidyTypeNotFixedAmount"
                        style="display: block"
                        [style]="subsidyTotalWithoutTaxStyle"
                        [value]="ctr['subsidyTotal'].value | currency: '' : ''"
                        tabindex="36"
                      />
                      @if (ctr['subsidyTotal'].value) {
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="isSubsidyTypeNotEmpty && isSubsidyTypeNotFixedAmount">
                  <div class="wrapperS1">
                    <div class="wrapperSX">
                      <label></label>
                      <span class="note">{{ 'Excluding VAT' | translate }}</span>
                    </div>
                  </div>
                  <div class="wrapperS2">
                    @if (getAutoFieldSubsidyTotal('withoutTax'); as valueWithoutTax) {
                      <span class="amountReadOnly xl gapRight" [style]="subsidyTotalWithoutTaxStyle">{{
                        valueWithoutTax | currency: '' : ''
                      }}</span>
                      <span>{{ currencySelected() }}</span>
                    }
                  </div>
                  <div class="wrapperSX">
                    <span class="note">{{ 'Including VAT' | translate }}</span>
                    <div>
                      @if (getAutoFieldSubsidyTotal('withTax'); as valueWithTax) {
                        <span class="amountReadOnly xl gapRight" [style]="subsidyTotalWithTaxStyle">{{
                          valueWithTax | currency: '' : ''
                        }}</span>
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <!-- Ballon -->
              <div class="rowGroup" *ngIf="hasBallonFields && isActiveBallon">
                <div class="row">
                  <div class="wrapperS1">
                    <label>Balloon</label>
                  </div>
                  <div class="wrapperSX">
                    <div class="innerWrapper">
                      <div class="selectWrapper size2">
                        <div class="customSelect">
                          <select
                            formControlName="balloonType"
                            (change)="changeBalloon('balloonTotalWithTax')"
                            data-select-id="balloonType"
                            dataSelectId
                            tabindex="37"
                          >
                            @for (taxType of taxTypeBalloonOptions; track taxType) {
                              <option
                                *ngIf="taxType.isValidToSelect(ctr['financialProductType'].value)"
                                [ngValue]="taxType.value"
                              >
                                {{ taxType.display }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                      <!-- Mostrar input de porcentaje solo si balloonType es porcentaje -->
                      <ng-container *ngIf="isBallonTypeNotNull && !isBallonTypeFixedAmount">
                        <input
                          type="number"
                          formControlName="balloonPercentage"
                          (change)="changeBalloon('balloonTotalWithTax')"
                          class="size0 percentage textAlignRight"
                          (keypress)="preventInvalidCharacters($event)"
                          data-select-id="balloonPercentage"
                          dataSelectId
                          tabindex="38"
                          appInputValidations
                        />
                        <span>%</span>
                      </ng-container>
                    </div>
                    <div class="innerWrapper" *ngIf="isBallonTypeNotNull && isBallonTypeFixedAmount">
                      <!-- Mostrar input de monto solo si balloonType es monto fijo -->
                      <input
                        type="number"
                        id="balloon"
                        class="amount"
                        style="display: none"
                        (blur)="changeBalloon('balloonTotalWithTax', 'balloon')"
                        formControlName="balloon"
                        (keypress)="preventInvalidCharacters($event)"
                        data-select-id="balloon"
                        dataSelectId
                        tabindex="39"
                      />
                      <input
                        type="text"
                        id="hidden-balloon"
                        class="amount gapRight"
                        (focus)="showAmountInput('balloon')"
                        [disabled]="!isBallonTypeFixedAmount"
                        [style]="balloonTotalWithoutTaxStyle"
                        style="display: block"
                        [value]="ctr['balloon'].value | currency: '' : ''"
                        tabindex="39"
                      />
                      @if (ctr['balloon'].value) {
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="isBalloonTypeNotEmpty && !isBallonTypeFixedAmount">
                  <div class="wrapperS1">
                    <div class="wrapperSX">
                      <label></label>
                      <span class="note">{{ 'Excluding VAT' | translate }}</span>
                    </div>
                  </div>
                  <div class="wrapperS2">
                    @if (getAutoFieldBalloonTotal('withoutTax'); as valueWithoutTax) {
                      <span class="amountReadOnly xl gapRight" [style]="balloonTotalWithoutTaxStyle">{{
                        valueWithoutTax | currency: '' : ''
                      }}</span>
                      <span>{{ currencySelected() }}</span>
                    }
                  </div>
                  <div class="wrapperSX">
                    <span class="note">{{ 'Including VAT' | translate }}</span>
                    <div>
                      @if (getAutoFieldBalloonTotal('withTax'); as valueWithTax) {
                        <span class="amountReadOnly xl gapRight" [style]="balloonTotalWithTaxStyle">{{
                          valueWithTax | currency: '' : ''
                        }}</span>
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <!-- Valor residual -->
              <div class="rowGroup" *ngIf="isFinancialProductTypePureLease">
                <div class="row">
                  <div class="wrapperS1">
                    <label>{{ 'Residual Value' | translate }} <span class="required">*</span></label>
                  </div>
                  <div class="wrapperSX">
                    <div class="innerWrapper">
                      <div class="selectWrapper size2">
                        <div class="customSelect">
                          <select
                            formControlName="residualValueType"
                            (change)="changeResidualValue('residualValueTotal')"
                            data-select-id="residualValueType"
                            dataSelectId
                            tabindex="40"
                          >
                            @for (option of residualValueTypeOptions; track option) {
                              <option [value]="option.value" [hidden]="option?.hidden">
                                @if (option.percentage) {
                                  %
                                }
                                {{ option.display | translate }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                      @if (isResidualValueTypeNotNull && isResidualValueTypeNotFixedAmount) {
                        <input
                          type="number"
                          formControlName="residualValuePercentage"
                          (blur)="changeResidualValue('residualValueTotal')"
                          class="size0 percentage textAlignRight gapRight"
                          (keypress)="preventInvalidCharacters($event)"
                          data-select-id="residualValuePercentage"
                          dataSelectId
                          tabindex="41"
                          appInputValidations
                        />
                        <span *ngIf="isResidualValueTypeNotFixedAmount">%</span>
                      }
                    </div>
                    <div class="innerWrapper" *ngIf="isResidualValueTypeNotNull && !isResidualValueTypeNotFixedAmount">
                      <input
                        type="number"
                        id="residualValueTotal"
                        class="amount gapRight"
                        style="display: none"
                        (blur)="changeResidualValue('residualValueTotal', 'residualValueTotal')"
                        formControlName="residualValueTotal"
                        (keypress)="preventInvalidCharacters($event)"
                        tabindex="42"
                      />
                      <input
                        type="text"
                        id="hidden-residualValueTotal"
                        class="amount gapRight"
                        (focus)="showAmountInput('residualValueTotal')"
                        [disabled]="isResidualValueTypeNotFixedAmount"
                        style="display: block"
                        [style]="residualValueTotalWithoutTaxStyle"
                        [value]="ctr['residualValueTotal'].value | currency: '' : ''"
                        tabindex="42"
                      />
                      @if (ctr['residualValueTotal'].value) {
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                </div>
                <div
                  id="residualValue-line-2"
                  class="row"
                  *ngIf="isResidualValueTypeNotNull && isResidualValueTypeNotFixedAmount"
                >
                  <div class="wrapperS1">
                    <div class="wrapperSX">
                      <label></label>
                      <span class="note">{{ 'Excluding VAT' | translate }}</span>
                    </div>
                  </div>
                  <div class="wrapperS2">
                    @if (getAutoFieldResidualValueTotal('withoutTax'); as valueWithoutTax) {
                      <span class="amountReadOnly xl gapRight" [style]="residualValueTotalWithoutTaxStyle">{{
                        valueWithoutTax | currency: '' : ''
                      }}</span>
                      <span>{{ currencySelected() }}</span>
                    }
                  </div>
                  <div class="wrapperSX">
                    <span class="note">{{ 'Including VAT' | translate }}</span>
                    <div>
                      @if (getAutoFieldResidualValueTotal('withTax'); as valueWithTax) {
                        <span class="amountReadOnly xl gapRight" [style]="residualValueTotalWithTaxStyle">{{
                          valueWithTax | currency: '' : ''
                        }}</span>
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <!-- Opción de compra -->
              <div class="rowGroup" *ngIf="isFinancialProductTypeFinancialLeasing">
                <div class="row">
                  <div class="wrapperS1">
                    <label>{{ 'Purchase Option' | translate }} <span class="required">*</span></label>
                  </div>
                  <div class="wrapperSX">
                    <div class="innerWrapper">
                      <div class="selectWrapper size2">
                        <div class="customSelect">
                          <select
                            formControlName="purchaseOptionType"
                            (change)="changePurchaseOption('purchaseTotalWithTax')"
                            data-select-id="purchaseOptionType"
                            dataSelectId
                            tabindex="43"
                          >
                            <option [value]="taxType.invoiceWithTax">% {{ 'valueIncludingVAT' | translate }}</option>
                            <option [value]="taxType.invoiceWithoutTax">% {{ 'valueExcludeVAT' | translate }}</option>
                            <option [value]="taxType.amountToFinance">% {{ 'Amount to Finance' | translate }}</option>
                            <option [value]="taxType.fixedAmount">{{ 'Fixed Amount' | translate }}</option>
                          </select>
                        </div>
                      </div>
                      @if (isPurchaseOptionTypeNotNull && isPurchaseOptionTypeNotFixedAmount) {
                        <input
                          type="number"
                          formControlName="purchasePercentage"
                          (blur)="changePurchaseOption('purchaseTotalWithTax')"
                          class="size0 percentage textAlignRight"
                          tabindex="44"
                          (keypress)="preventInvalidCharacters($event)"
                          data-select-id="purchasePercentage"
                          dataSelectId
                          appInputValidations
                        />
                        <span *ngIf="isPurchaseOptionTypeNotFixedAmount">%</span>
                      }
                    </div>
                    <div
                      class="innerWrapper"
                      *ngIf="isPurchaseOptionTypeNotNull && !isPurchaseOptionTypeNotFixedAmount"
                    >
                      <input
                        type="number"
                        id="purchaseTotal"
                        class="amount gapRight"
                        style="display: none"
                        (blur)="changePurchaseOption('purchaseTotalWithTax', 'purchaseTotal')"
                        (keypress)="preventInvalidCharacters($event)"
                        formControlName="purchaseTotal"
                        tabindex="45"
                      />
                      <input
                        type="text"
                        id="hidden-purchaseTotal"
                        class="amount gapRight"
                        (focus)="showAmountInput('purchaseTotal')"
                        [disabled]="isPurchaseOptionTypeNotFixedAmount"
                        [style]="purchaseTotalWithoutTaxStyle"
                        style="display: block"
                        [value]="ctr['purchaseTotal'].value | currency: '' : ''"
                        tabindex="45"
                      />
                      @if (ctr['purchaseTotal'].value) {
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                </div>
                <div
                  id="purchaseOption-line-2"
                  class="row"
                  *ngIf="isPurchaseOptionTypeNotNull"
                >
                  <div class="wrapperS1">
                    <div class="wrapperSX">
                      <label></label>
                      <span class="note">{{ 'Excluding VAT' | translate }}</span>
                    </div>
                  </div>
                  <div class="wrapperS2">
                    @if (getAutoFieldPurchaseTotal('withoutTax'); as valueWithoutTax) {
                      <span class="amountReadOnly xl gapRight" [style]="purchaseTotalWithoutTaxStyle">{{
                        valueWithoutTax | currency: '' : ''
                      }}</span>
                      <span>{{ currencySelected() }}</span>
                    }
                  </div>
                  <div class="wrapperSX">
                    <span class="note">{{ 'Including VAT' | translate }}</span>
                    <div>
                      @if (getAutoFieldPurchaseTotal('withTax'); as valueWithTax) {
                        <span class="amountReadOnly xl gapRight" [style]="purchaseTotalWithTaxStyle">{{
                          valueWithTax | currency: '' : ''
                        }}</span>
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tipo de pago -->
              <div class="row">
                <div class="wrapperS1">
                  <label>{{ 'Payment Type' | translate }} <span class="required">*</span></label>
                </div>
                <div class="selectWrapper size2">
                  <div class="customSelect">
                    <select formControlName="paymentType" tabindex="46" (change)="onlyChangeValue()">
                      <option [value]="'PREPAID'">{{ 'Advance' | translate }}</option>
                      <option [value]="'EXPIRATION'">{{ 'Due' | translate }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Forma de amortización -->
              <div class="row">
                <div class="wrapperS1">
                  <label>{{ 'Amortization Method' | translate }} <span class="required">*</span></label>
                </div>
                <div class="selectWrapper size2">
                  <div class="customSelect">
                    <select formControlName="paymentFormationType" tabindex="47" (change)="onlyChangeValue()">
                      <option [value]="'LEVELED'">{{ 'Level Payment' | translate }}</option>
                      <!-- <option [value]="'DESCENDING'">{{ 'Decreasing Payment' | translate }}</option> -->
                    </select>
                  </div>
                </div>
              </div>

              <!-- Gastos de ratificación -->
              <div class="row">
                <div class="wrapperS1">
                  <label>{{ 'Ratification Fees' | translate }}</label>
                </div>
                <div class="wrapperSX flexEnd">
                  <input
                    type="number"
                    id="ratificationExpensesAmount"
                    class="amount"
                    style="display: none"
                    formControlName="confirmationExpensesAmount"
                    (blur)="onlyChangeValue('ratificationExpensesAmount')"
                    (keypress)="preventInvalidCharacters($event)"
                    data-select-id="confirmationExpensesAmount"
                    dataSelectId
                    tabindex="48"
                  />
                  <input
                    type="text"
                    id="hidden-ratificationExpensesAmount"
                    class="amount"
                    (focus)="showAmountInput('ratificationExpensesAmount')"
                    style="display: block"
                    [value]="ctr['confirmationExpensesAmount'].value | currency: '' : ''"
                    tabindex="48"
                  />
                  <span>{{ currencySelected() }}</span>
                </div>
              </div>

              <!-- Factor seguro de vida -->
              <div *ngIf="isLifeInsuranceApplicable()" class="row">
                <div class="wrapperS1">
                  <label>{{ 'Life Insurance Factor' | translate }}</label>
                </div>
                <div class="wrapperSX flexStart">
                  <input
                    type="number"
                    id="lifeInsuranceFactor"
                    class="amount"
                    style="display: none"
                    formControlName="lifeInsuranceFactor"
                    (blur)="onlyChangeValue('lifeInsuranceFactor')"
                    (keypress)="preventInvalidCharacters($event)"
                    data-select-id="lifeInsuranceFactor"
                    dataSelectId
                    tabindex="49"
                  />
                  <input
                    type="text"
                    id="hidden-lifeInsuranceFactor"
                    class="amount"
                    (focus)="showAmountInput('lifeInsuranceFactor')"
                    style="display: block"
                    [value]="ctr['lifeInsuranceFactor'].value ?? ''"
                    tabindex="49"
                  />
                  <span style="color: rgba(0, 0, 0, 0.5)">(max 2)</span>
                </div>
              </div>

              <!-- Colateral adicional -->
              <div class="row" *ngIf="isNormalCreditOrCreditGlobe || isCapLoanOrRealEstate()">
                <div class="wrapperS1">
                  <label>{{ 'Additional Collateral' | translate }}</label>
                </div>
                <div class="wrapperSX">
                  <div class="innerWrapper">
                    <div class="selectWrapper size2 gapRight">
                      <div class="customSelect">
                        <select
                          formControlName="additionalCollateralType"
                          (change)="calculateAdditionalCollateral()"
                          data-select-id="additionalCollateralType"
                          dataSelectId
                          tabindex="50"
                        >
                          @for (option of additionalCollateralTypeOptions; track option) {
                            <option [value]="option.value">{{ option.display }}</option>
                          }
                        </select>
                      </div>
                    </div>
                    <ng-container
                      *ngIf="
                        ctr['additionalCollateralType'].value === 'UNIT_VALUE' ||
                        ctr['additionalCollateralType'].value === 'TOTAL_VALUE'
                      "
                    >
                      <input
                        type="number"
                        formControlName="additionalCollateralPercentage"
                        (blur)="calculateAdditionalCollateral()"
                        class="size0 percentage textAlignRight gapRight"
                        (keypress)="preventInvalidCharacters($event)"
                        data-select-id="additionalCollateralPercentage"
                        dataSelectId
                        tabindex="51"
                        appInputValidations
                      />
                      <span>%</span>
                    </ng-container>
                  </div>
                  <div
                    class="innerWrapper"
                    *ngIf="
                      ctr['additionalCollateralType'].value === 'UNIT_VALUE' ||
                      ctr['additionalCollateralType'].value === 'TOTAL_VALUE'
                    "
                  >
                    <span class="amount gapRight">{{
                      ctr['additionalCollateralTotal'].value | currency: '' : ''
                    }}</span>
                    <span *ngIf="ctr['additionalCollateralType'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Seguro broker -->
          <app-insurance
            *ngIf="canAddInsurance() && !isFinancialProductCapLoanOrRealEstate"
            formControlName="insurance"
            (updateInsurance)="calculateQuote('r')"
            (resetInsurance)="resetInsurance($event)"
            [idDeal]="ctr['id'].value"
            [idQuote]="idQuote"
            [isValid]="isValid()"
            [isModelValid]="isFormValidExceptInsurance()"
            [quoteType]="quoteComponentType"
            [dealerId]="insuranceService.dealerId()"
            [dealerBranchId]="insuranceService.dealerBranchId()"
            [hasManualInsurance]="hasManualInsurance"
          ></app-insurance>
          <!-- Calculation results -->
          <app-calculate-diro
            [profitDeal]="ctr['profitDeal'].value"
            (updateDataDiro)="assignProfitDeal($event)"
          ></app-calculate-diro>
        </div>
        <div class="actionWrapper">
          <button (click)="calculateQuote('r', 'v1')" [disabled]="isDisabledCalculateQuote" tabindex="90">
            Calcular
          </button>
          @if (isActiveCalculateV2) {
            <button (click)="calculateQuote('r', 'v2')" [disabled]="isDisabledCalculateQuoteV2" tabindex="90">
              Calcular v2
            </button>
          }
          <button
            (click)="calculateDiro('r')"
            [disabled]="!formGroup.valid || !hasCalculatedResult"
            *ngIf="diroService.activeDiro"
            tabindex="91"
          >
            Sincronizar DIRO
          </button>

          <button
            (click)="calculateQuoteToDownloadJson()"
            [disabled]="isDisabledCalculateQuoteToDownloadJson"
            tabindex="92"
          >
            Descargar JSON
          </button>
          <p class="note">Para calcular una cotización es necesario completar todos los campos requieridos.</p>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- Amortizations -->

<div class="module">
  <!-- Si tiene seguro usar clase "w3", si no usar clase "w2"-->
  <div
    class="tabs w3"
    [ngClass]="{
      w4: isActiveBrokerCatalog && isInsuranceCalculated && isAvailableInsurancePayments,
      w3: isActiveBrokerCatalog && isInsuranceCalculated && !isAvailableInsurancePayments,
      w2: !isActiveBrokerCatalog || !isInsuranceCalculated,
    }"
  >
    <a
      (click)="selectSection(1)"
      (keydown.enter)="selectSection(1)"
      tabindex="93"
      [ngClass]="{ active: showSection == 1 }"
      >Amortizaciones ({{ currency }})</a
    >
    <a
      (click)="selectSection(2)"
      (keydown.enter)="selectSection(2)"
      tabindex="94"
      [ngClass]="{ active: showSection == 2 }"
      ><span class="pagosEspeciales">Períodos de gracia y pagos especiales</span></a
    >
    @if (isActiveBrokerCatalog && isInsuranceCalculated) {
      <a
        (click)="selectSection(3)"
        (keydown.enter)="selectSection(3)"
        tabindex="95"
        [ngClass]="{ active: showSection == 3 }"
        >Seguro</a
      >
    }
    @if (isActiveBrokerCatalog && isAvailableInsurancePayments) {
      <a
        (click)="selectSection(4)"
        (keydown.enter)="selectSection(4)"
        tabindex="96"
        [ngClass]="{ active: showSection == 4 }"
        >Amortizaciones seguro ({{ currency }})</a
      >
    }
  </div>
  <div>
    @if (showSection == 1) {
      <app-payments
        [payments]="ctr['payments'].value"
        [specialPayments]="ctr['specialPayments'].value"
        [grace]="ctr['grace'].value"
        [irregularPayments]="ctr['irregularPayments'].value"
        [quantity]="quantityForPayments"
        [currency]="currency"
        [idDeal]="ctr['id'].value"
        [idQuote]="idQuote"
        [quoteType]="this.quoteType"
        [financialAmount]="ctr['financialAmount'].value"
        [tipoProductoFinanciero]="ctr['financialProductType'].value ?? null"
        (updateGrace)="updateGrace($event)"
        (updateSpecialPayments)="updateSpecialPayments($event)"
        (updateIrregularPayments)="updateIrregularPayments($event)"
        [isCalculateDisable]="isDisableEditPayments"
      >
      </app-payments>
    } @else if (showSection == 2) {
      <app-list-special-payments-grace-period-open
        [payments]="ctr['payments'].value"
        [specialPayments]="ctr['specialPayments'].value"
        [grace]="ctr['grace'].value"
        [irregularPayments]="ctr['irregularPayments'].value"
        [idQuote]="idQuote"
        [idDeal]="ctr['id'].value"
        [financialProduct]="ctr['financialProductType'].value"
        [financialAmount]="ctr['financialAmount'].value"
        (updateGrace)="updateGrace($event)"
        (updateSpecialPayments)="updateSpecialPayments($event)"
        (updateIrregularPayments)="updateIrregularPayments($event)"
        [quoteType]="this.quoteType"
        [isCalculateDisable]="isDisableEditPayments"
      >
      </app-list-special-payments-grace-period-open>
    } @else if (showSection == 3) {
      <app-insurance-list-payments [quantity]="ctr['quantity'].value" [coverage]="formInsurance" />
    } @else {
      <app-insurance-amortizations
        [payments]="insurancePayments"
        [quantity]="ctr['quantity'].value"
        [currency]="currency"
        [readOnly]="true"
        [tipoProductoFinanciero]="ctr['financialProductType'].value"
        [grace]="ctr['grace'].value"
      ></app-insurance-amortizations>
    }
  </div>
</div>

<div class="quotationActions">
  <button (click)="cancel()" class="secondary" tabindex="97">Volver</button>
  <button (click)="save()" [disabled]="!formGroup.valid" class="primary" tabindex="98">Guardar</button>
  <p class="note">Para Guardar un cotización es necesario sincronizar los datos con DIRO.</p>
</div>
<ng-template #modalTemplate>
  <div class="modal" style="max-width: 620px">
    <a class="close">Cerrar</a>
    <h1>Eliminar seguros</h1>
    <p>
      Esta editando datos sensibles, si continúa con los cambios todos los seguros generados anteriormente seran
      eliminados.
    </p>
    <div class="modalActions index">
      <button class="secondary">Cancelar</button>
      <button (click)="deleteAllInsurance()" class="primary">Eliminar</button>
    </div>
  </div>
</ng-template>
<ng-template #modalDiroLogin>
  <app-modal-diro-login (closed)="closedDiroModal($event)" />
</ng-template>
<ng-template #modalStatus>
  <app-modal-status [data]="diroService.getStatusModalData()" />
</ng-template>
<ng-template #modalConfirmation>
  <app-template-confirmation
    [title]="confirmationData().title"
    [subtitle]="confirmationData().subtitle"
    [btn1]="confirmationData().btn1"
    [btn2]="confirmationData().btn2"
    (closeModal)="closeConfirmationModal()"
    (actionBtn2)="confirmationByType()"
  ></app-template-confirmation>
</ng-template>
